<template>
  <div class="app-mfa-handler" v-if="isMfaActive">
    <MfaInput v-if="getRemainingAttempts > 0" @close="closeMfa" @completed="completed">
      <template v-for="slot in possibleChildSlotsFor('Input')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </MfaInput>
    <MfaHotline v-else @close="closeMfa">
      <template v-for="slot in possibleChildSlotsFor('Support')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </MfaHotline>
  </div>
</template>

<script>
import MfaInput from '@/components/process/generic/Mfa/MfaInput.vue'
import MfaHotline from '@/components/process/generic/Mfa/MfaHotline.vue'
import { mapGetters, mapMutations } from 'vuex'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'MfaHandler',
  components: {
    MfaInput,
    MfaHotline
  },
  mixins: [
    slotProxy()
  ],
  mounted () {
    this.setMfaStatus(false)
  },
  computed: {
    ...mapGetters('mfa', [
      'isMfaActive',
      'getRemainingAttempts'
    ])
  },
  methods: {
    ...mapMutations('mfa', [
      'setMfaStatus'
    ]),
    closeMfa () {
      this.setMfaStatus(false)
      this.$emit('close')
    },
    completed () {
      this.$emit('completed')
      this.setMfaStatus(false)
    }
  }
}
</script>
